import { dispatchErrorWrap, dispatchSuccessWrap } from './genericActions'

import { actionTypes } from '../types'
import { constants } from '../../App.constants';
import moment from 'moment-timezone'

import axios from 'axios';

export const canRegister = (email, callback) => {
    return async (dispatch) => {
        try {
            let header = {
                headers: {
                    'Content-Type': 'application/json'
                }
            }

            let reqPayload = {
                email: email
            }

            const payload = await axios.post(constants.apiUrl + "/auth/canRegisterWithDetails", reqPayload, header);
            if (payload.data) {

                dispatchSuccessWrap(actionTypes.CAN_REGISTER, { reset: payload.data }, dispatch);
                callback(null, payload.data.canRegister);

            }

        } catch (error) {
            callback('Unable to verify email');
            dispatchErrorWrap('Unable to verify email', dispatch);
            //dispatchErrorWrap(actionTypes.SIGN_IN, { isLoginTokenValid: false, currentUser: null, stripeConnected: false }, dispatch);
        }
    }
}
export const autoLoginUser = (token) => {
    return async (dispatch) => {
        let header = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': token
            }
        }
        try {
            const payload = await axios.get(constants.apiUrl + "/account/", header);
            let stripeConnected;
            if (payload.data && payload.data.userId) {

                localStorage.setItem('loginToken', token);
                localStorage.setItem('email', payload.data.email);
                localStorage.setItem('userId', payload.data.userId);
                localStorage.setItem('userName', payload.data.name);
                localStorage.setItem('user', JSON.stringify(payload.data));

                let headerForStripeCheck = {
                    headers: {
                        'Content-Type': 'application/json',
                        'login-token': token
                    }
                }

                try {
                    const payloadForStripeVerification = await axios.get(constants.ticketsBaseUrl + "/connectedUser", headerForStripeCheck);
                    payloadForStripeVerification.data.connected
                        ? stripeConnected = true
                        : stripeConnected = false
                } catch (err) { }

                dispatchSuccessWrap(actionTypes.SIGN_IN, { isLoginTokenValid: true, currentUser: payload.data, stripeConnected: stripeConnected }, dispatch);

            }


        } catch {
            dispatchErrorWrap(actionTypes.SIGN_IN, { isLoginTokenValid: false, currentUser: null, stripeConnected: false }, dispatch);

        }

    }
}
/**
 * Exchanges a one-time token from a one-click email link for a real session.
 *
 * The link carries only this token - never a login token. A session token in
 * a URL never expires, cannot be revoked, stays in browser history, is copied
 * when the link is shared, and rides along in the Referer header of later
 * requests. This one is single-use and expires in minutes; the API swaps it
 * for an ordinary session, so everything downstream is unchanged.
 *
 * Returns the same shape as signIn, because the API reuses the same formatter.
 */
export const redeemAutoLoginToken = (token, callback) => {
    return async (dispatch) => {
        try {
            const header = { headers: { 'Content-Type': 'application/json' } }

            const payload = await axios.post(constants.apiUrl + "/auth/autologin/redeem", { token }, header)

            if (payload.data && payload.data.loginToken) {
                localStorage.setItem('loginToken', payload.data.loginToken);
                localStorage.setItem('email', payload.data.email);
                localStorage.setItem('userId', payload.data.userId);
                localStorage.setItem('userName', payload.data.name);
                localStorage.setItem('user', JSON.stringify(payload.data));

                dispatchSuccessWrap(actionTypes.SIGN_IN, { isLoginTokenValid: true, currentUser: payload.data }, dispatch);
                if (callback) { callback(null, payload.data); }
                return
            }

            // A 200 carrying no session is not a sign-in.
            if (callback) { callback('Link is no longer valid'); }

        } catch (error) {
            // Expired, already used, or never valid - the API answers the same
            // for all three on purpose, and so do we. The caller falls back to
            // the login form rather than showing an error page.
            const status = error && error.response ? error.response.status : undefined
            console.error('autologin redeem failed', { status })
            if (callback) { callback('Link is no longer valid'); }
        }
    }
}

export const signIn = (values, callback) => {
    return async (dispatch) => {
        try {
            let header = {
                headers: {
                    'Content-Type': 'application/json',
                    'login-token': localStorage.getItem('loginToken')
                }
            }

            let reqPayload = values;

            const payload = await axios.post(constants.apiUrl + "/auth/login", reqPayload, header);
            if (payload.data) {

                localStorage.setItem('loginToken', payload.data.loginToken);
                localStorage.setItem('email', payload.data.email);
                localStorage.setItem('userId', payload.data.userId);
                localStorage.setItem('userName', payload.data.name);
                localStorage.setItem('user', JSON.stringify(payload.data));
                dispatchSuccessWrap(actionTypes.SIGN_IN, { isLoginTokenValid: true, currentUser: payload.data }, dispatch);
                callback(null, payload.data);

            }

        } catch (error) {
            // A 4xx means the API rejected the login. No status (network / CORS
            // failure, or an exception after the response) or a 5xx is not a
            // credentials problem, so say so and keep the real cause in the console.
            const status = error && error.response ? error.response.status : undefined
            const detail = error && error.response ? error.response.data : error && error.message
            console.error('signIn failed', { status, detail })
            const message = status && status < 500 ? 'Invalid Credentials' : 'Login failed, please try again'
            callback(message);
            dispatchErrorWrap(message, dispatch);
        }

    }


}

export const resetPassword = (values, callback) => {
    return async (dispatch) => {
        try {
            let header = {
                headers: {
                    'Content-Type': 'application/json',
                    'login-token': localStorage.getItem('loginToken')
                }
            }

            let reqPayload = values

            const payload = await axios.post(constants.apiUrl + "/account/resetPassword", reqPayload, header);
            if (payload.data) {

                dispatchSuccessWrap(actionTypes.RESET_PASSWORD, { reset: payload.data }, dispatch);

            }

            callback(null);


        } catch (error) {
            callback('Unable to send reset password email');
            dispatchErrorWrap('Unable to send reset password email', dispatch);
            //dispatchErrorWrap(actionTypes.SIGN_IN, { isLoginTokenValid: false, currentUser: null, stripeConnected: false }, dispatch);
        }

    }


}

export const signUp = (values, callback) => {
    return async (dispatch) => {
        try {
            let header = {
                headers: {
                    'Content-Type': 'application/json'
                }
            }

            let reqPayload = {
                "email": values.email,
                "password": values.password,
                "timezone": moment.tz.guess(),
                "name": values.name,
                "hasAcceptedLatestTerms": true,
                // Tanglewood members get Tanglewood's emails only: the core API
                // skips its "confirm your account" email when this is false.
                "sendEmailOnRegister": false
            }

            const payload = await axios.post(constants.apiUrl + "/auth/register", reqPayload, header);
            if (payload.data) {

                localStorage.setItem('loginToken', payload.data.loginToken);
                localStorage.setItem('email', payload.data.email);
                localStorage.setItem('userId', payload.data.userId);
                localStorage.setItem('userName', payload.data.name);
                localStorage.setItem('user', JSON.stringify(payload.data));
                dispatchSuccessWrap(actionTypes.SIGN_UP, { isLoginTokenValid: true, currentUser: payload.data }, dispatch);
                callback(null, payload.data);

            }

        } catch (error) {
            callback('Invalid Credentials');
            dispatchErrorWrap('Invalid Credentials', dispatch);
            //dispatchErrorWrap(actionTypes.SIGN_IN, { isLoginTokenValid: false, currentUser: null, stripeConnected: false }, dispatch);
        }

    }


}

export const autoSignOut = () => {
    return async (dispatch) => {
        localStorage.removeItem('loginToken');
        localStorage.removeItem('email');
        localStorage.removeItem('userId');
        localStorage.removeItem('userName');
        localStorage.removeItem('user');
        // dispatchSuccessWrap(actionTypes.RESET_POSTINGS_STATE, {}, dispatch)
        dispatchSuccessWrap(actionTypes.SIGN_OUT, { isLoginTokenValid: false, currentUser: undefined }, dispatch)
    }

}

export const signOut = (cb) => {
    return async (dispatch, getState) => {
        try {
            const headers = {
                headers: {
                    'Content-Type': 'application/json',
                    'login-token': localStorage.getItem('loginToken')
                }
            }
            let reqPayload = JSON.parse(localStorage.getItem('user'));

            await axios.post(constants.apiUrl + "/auth/logout", reqPayload, headers);
            localStorage.removeItem('loginToken');
            localStorage.removeItem('email');
            localStorage.removeItem('userId');
            localStorage.removeItem('userName');
            localStorage.removeItem('user');
            //dispatchSuccessWrap(actionTypes.RESET_POSTINGS_STATE, {}, dispatch)
            dispatchSuccessWrap(actionTypes.SIGN_OUT, { isLoginTokenValid: false, currentUser: undefined }, dispatch)
            cb()
        } catch (error) {
            dispatchErrorWrap(error, dispatch);
        }

    }


}

export const checkIfLoggedIn = (cb) => {
    return async (dispatch, getState) => {

        let isLoginTokenValid = false;
        let currentUser;

        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': localStorage.getItem('loginToken')
            }
        }

        try {

            const payload = await axios.get(constants.apiUrl + "/account", headers);
            //console.log('payload cal Info', payload);
            if (payload.data && payload.data.userId) {
                isLoginTokenValid = true;
                currentUser = payload.data;
                cb(payload.data)
            } else {
                isLoginTokenValid = false;
                cb(null)
            }

        } catch (error) {
            isLoginTokenValid = false;
            cb(null)
        }
        console.log(isLoginTokenValid);
        dispatchSuccessWrap(actionTypes.CHECK_AUTHENTICATION_TOKEN, {
            isLoginTokenValid: isLoginTokenValid,
            currentUser: currentUser
        }, dispatch)

    }
}


